import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { VaccinesListFiltersArray } from './Filters'

const VaccinesListFilters: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {VaccinesListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default VaccinesListFilters
